module.exports = __webpack_public_path__ + "media/images/checkmark-black-and-green-9d01b531bd20c611b97a172af968ec82.svg";